import { useState } from "preact/hooks";
import { readSeed } from "../../seeds";

/**
 * The prerendered data of this page, read once when the page is first rendered. A seed that the page does not
 * accept (the url changed, or the page was reached by navigation) counts as none, so the page loads its own data.
 */
export const useSeed = <T>(key: string, accepts: (seed: T) => boolean = () => true): T | undefined => {
  const [seed] = useState(() => {
    const found = readSeed<T>(key);
    return found !== undefined && accepts(found) ? found : undefined;
  });
  return seed;
};
